<template>
    <div class="col-12 col-md-4 my-2" v-if="gateway.gateway_type == gateway_type && (!gtype || gateway.type == gtype)">
        <div class="h-100 bg-white gw-card m-2" :class="'gw-' + variant(gateway.status)">
            <div class="ribbon shadow-sm" id="coming_soon_pasargad" style="margin-top:6px; margin-left: -2.8px; border-top-left-radius: 10px; border-bottom-left-radius: 0">

                <div v-if="gateway.gateway_type === gatewayTypes.PARDAKHTYARI">{{shopTypeStr.get(gtype)}}</div>
                <div v-else-if="gateway.gateway_type === gatewayTypes.IVR && gtype === 1">تلفنی</div>
                <div v-else-if="gateway.gateway_type === gatewayTypes.IVR && gtype === 2">شناسه دار</div>
                <div v-else-if="gateway.gateway_type === gatewayTypes.CARD_TO_CARD">تایید کارت به کارت</div>
            </div>
            <div class="d-flex align-items-center">
                <div class="gw-logo">
                    <img v-if="gateway.logo" :src="gateway.logo" alt="logo" class="mw-100 mh-100">
                    <span v-else>{{ (gateway.title || '').trim().charAt(0) }}</span>
                </div>
                <div class="mx-auto">
                    <div class="gw-title">{{ gateway.title }}</div>
                    <div class="gw-status-row">
            <span :class="'gw-status gw-status--' + variant(gateway.status)">

                                {{ statusStr(gateway.status) }}

                                <i
                                        :title="gateway.rejection_reason"
                                        aria-hidden="true"
                                        class="fa fa-exclamation-triangle"
                                        data-toggle="tooltip"
                                        style="color: orangered!important; cursor: pointer"
                                        v-if="gateway.rejection_reason && gateway.status == gatewayStatus.REJECTED"
                                ></i>
                            </span>

                        <span class="position-absolute" data-toggle="dropdown"
                              style="cursor: pointer; color: orangered" v-if="gateway.response_rejection_reason">
                                <i aria-hidden="true" class="fa fa-info-circle" style="font-size: 1.6em;"></i>
                            </span>

                        <ul class="dropdown-menu" v-if="gateway.response_rejection_reason">
                            <div class="dropdown-header">{{ $t('gateway.btn.rejection_reason') }}</div>
                            <li :key="index" class="text-center"
                                v-for="(reason, index) in gateway.response_rejection_reason">
                                {{ reason.fieldName }} {{ ' : ' }} {{ reason.codeExceptionValue }}
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <div class="btn-group">
                    <button class="btn p-1 rounded" data-toggle="dropdown" type="button">
                        <svg fill="gray" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path
                                    d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                        </svg>
                    </button>
                    <div class="dropdown-menu text-right">
                        <router-link :to="updateUrl(gateway.gateway_type, gateway.type) + gateway.id + (gateway.gateway_type == gatewayTypes.PARDAKHTYARI ? '/gateway-form?editDargah=true' : '')"
                                     class="dropdown-item">
                            ویرایش درگاه
                        </router-link> -->
<!--                        <router-link v-if="gateway.gateway_type === 0 && gateway.type === 2" to="/stakeholders"-->
<!--                                     class="dropdown-item">-->
<!--                            شریکان تجاری-->
<!--                        </router-link>-->
                        <!-- <router-link v-if="gateway.gateway_type === 0 && gateway.type === 2" :to="allotmentUrl(gateway.gateway_type) +  gateway.id"
                                     class="dropdown-item">
                            تسهیم درگاه
                        </router-link>
                        <router-link v-if="(gateway.gateway_type === 0 && gateway.type === 2) || gateway.gateway_type === gatewayTypes.PARDAKHTYARI" :to="getLink(gateway.id)"
                                     class="dropdown-item">
                            نماد اعتماد
                        </router-link>
                        <router-link
                            v-if="gateway.show_psp_report_to_user == 1 && gateway.terminal.length"
                            :to="`/gateways/transactions-report/${gateway.id}`"
                            class="dropdown-item"
                        >
                            استعلام تراکنش های psp
                        </router-link>
                        <a :data-target="'#gatewayKeyModal' + gateway.id"
                           @click="getSign(gateway.id, gateway.gateway_type)"
                           class="dropdown-item"
                           data-toggle="modal"
                           href="#" v-if="gateway.gateway_type === gatewayTypes.PARDAKHTYARI || gateway.gateway_type === gatewayTypes.DEDICATED"
                        >
                  <span>
                      نمایش کلید
                  </span>
                        </a>

                    </div>
                </div>   -->
                                                </div>
                <div class="gw-chip gw-url" v-if="gateway.website_address">
                    <div class="mx-auto shadow-sm d-flex text-left justify-content-center"
                     style="box-shadow: none!important;" >
                    <div>
                        <a :href="gateway.website_address" target="_blank">{{gateway.website_address}}</a>
                    </div>
                    <div class="mr-1">
                        <i class="fa fa-link"></i>
                    </div>
                </div>
            </div>

            <div class="my-3">
                <div class="gw-chip gw-id d-flex justify-content-between align-items-center">
                    <div>
                        <small class="pr-2" v-if="gateway.variant == shop_type.PARDAKHT_SHAKHSI">لینک:</small>
                        <small class="pr-2" v-else>شناسه درگاه:</small>
                    </div>
                    <div>
                        <input :id="'myInput' + gindex"
                               :value="PAYMENT_LINK_URL() + current_user.username"
                               class="text-center px-0 border-0 rounded en_num"
                               readonly
                               size="25"
                               v-if="gateway.variant == 1"
                               v-show="!copied"
                        >
                        <input :id="'myInput' + gindex"
                               :value="gateway.website_address"
                               class="text-center px-0 border-0 rounded en_num"
                               readonly
                               size="25"
                               v-if="gateway.variant == 2"
                               v-show="!copied"
                        >
                        <input :id="'myInput' + gindex"
                               :value="gateway.sequence"
                               class="text-center px-0 border-0 rounded en_num text-dark router-link-white"
                               readonly
                               size="15"
                               v-if="gateway.variant == 3 || gateway.variant == null"
                               v-show="!copied"
                        >
                    </div>
                    <div>
                        <button @click="copy" class="btn" title="کپی کردن">
                            <svg fill="gray" height="15px" viewBox="0 0 24 24" width="15px"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                        d="M0 0h24v24H0V0z" fill="none"/>
                                <path
                                        d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row" v-if="gateway.gateway_type == gatewayTypes.CARD_TO_CARD">
                <div class="col-8" style="padding-left: 7px" id="charge-monthly-credit">
                    <label>
                        <small class="pr-2">تعرفه اشتراک:</small>
                    </label>
                    <div class="my-3 border bg-white w-auto pt-2" style="border-radius: 10px; height: 30px;margin-top: 0 !important;">
                        <div class="mx-auto shadow-sm d-flex text-left justify-content-center"
                             style="box-shadow: none!important;" >
                            <small class="pr-2">تاریخ پایان اشتراک:</small>
                            <small class="pr-2">{{gateway.recharge_expire_date}}</small>
                        </div>
                    </div>
                </div>
                <div class="col-4" style="padding-right: 0">
                       <span class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm rounded-circle"
                             style="position:absolute;left: 9px;top: -3px">
                          <span class="tooltip-text">
                             قابل پرداخت {{moneyFormat(gateway.monthly_credit_price)}} ریال
                          </span>
                              <i style="color: #00bea5" class="fas fa-exclamation-circle"></i>
                       </span>
                    <kt-button
                        style="margin-top: 25px;border-radius: 7px;width: 100%;font-size: smaller;padding: 6px"
                        class="btn-font-sm"
                        size="md"
                        :disabled="!gateway.monthly_credit_price || gateway.status != cardToCardStatus.ACTIVE"
                        @click="rechargeMonthlyCharge"
                        variant="success"
                        v-bind:wide="true"
                        id="monthly_recharge_btn"
                    >
                     پرداخت اشتراک
                    </kt-button>
                </div>
                <div class="col-8" style="padding-left: 7px">
                    <label>
                        <small class="pr-2">موجودی کیف پول:</small>
                    </label>
                    <div class="my-3 border bg-white w-auto pt-2" style="border-radius: 10px; height: 30px;margin-top: 0 !important;">
                        <div class="mx-auto shadow-sm d-flex text-left justify-content-center"
                             style="box-shadow: none!important;" >
                            <small class="pr-2">{{ moneyFormat(gateway.card_to_card_wallet_balance) + " " + $t("label.rial") }}</small>
                        </div>
                    </div>
                </div>
                <div class="col-4" style="padding-right: 0">
                    <router-link style="margin-top: 25px!important;border-radius: 7px;width: 100%;font-size: smaller;padding: 6px;margin-right: 0!important;"
                                 class="btn btn-outline-success m-1"
                                 to="/user-setting/card-to-card-wallet">
                        شارژ کیف پول
                    </router-link>
                </div>

            </div>
            <hr v-else style="border-top: 1px solid #dedede;">

            <div class=" mt-2  text-center" v-if="gateway.gateway_type != gatewayTypes.CARD_TO_CARD">
                <div class="my-2" v-if="gateway.status === gatewayStatus.AWAITING_CONTRACT">
                    <button type="button" class="btn btn-success btn-block" style="border-radius: 10px;"
                            @click="$emit('sign-contract', gateway.id)">
                        مطالعه و امضای قرارداد
                    </button>
                    <router-link :to="`/gateways/update/${gateway.id}/gateway-form`" class="btn btn-outline-success btn-block mt-2" style="border-radius: 10px;">ویرایش اطلاعات درگاه</router-link>
                </div>
                <div class="d-flex align-items-center" v-else-if="gateway.status !== gatewayStatus.ENAMAD_PENDING">
                    <div class="p-1 w-50">
                        <router-link  disabled="disabled" :to="settlementSettingsUrl(gateway.gateway_type)"  class="btn btn-outline-success btn-block">تنظیمات تسویه</router-link>
                    </div>
                    <div class="p-1 w-50">
                        <button
                            v-if="(gateway.gateway_type === gatewayTypes.IVR && (gtype === 2 || gtype === 1))
                            || (gateway.gateway_type === gatewayTypes.PARDAKHTYARI && (gtype === 1 || gtype === 3)) || gateway.gateway_type == gatewayTypes.CARD_TO_CARD"
                            disabled  class="btn btn-outline-success btn-block">تغییر شبای تسویه</button>

                        <!-- <router-link v-else disabled="disabled" :to="updateUrl(gateway.gateway_type) + gateway.id + (gateway.gateway_type == gatewayTypes.PARDAKHTYARI ? '/changes-requests' : '')"  class="btn btn-outline-success btn-block">افزودن شبا به درگاه</router-link> -->
                        <router-link v-else disabled="disabled" :to="updateUrl(gateway.gateway_type, gateway.type) + gateway.id + (gateway.gateway_type == gatewayTypes.PARDAKHTYARI ? '/gateway-form' : '')"  class="btn btn-outline-success btn-block">ویرایش درگاه</router-link>
                    </div>
                </div>
                <div class="my-4 d-flex align-items-center" v-else>
                    <router-link :to="enamadPending(gateway.id)" class="btn btn-block m-2"
                                 style="border-radius: 10px; color: #00c1a4; background-color: #d6f5f0;">
                        ادامه فرآیند دریافت اینماد
                    </router-link>
                </div>
                <div class="d-flex align-items-center">
                    <div class="p-1 w-50">
                        <!-- <router-link v-if="gateway.gateway_type === 0 && gateway.type === 2" to="/stakeholders"  class="btn btn-outline-success btn-block h-100">شرکای تجاری</router-link>
                        <button v-else disabled  class="btn btn-outline-success btn-block">شرکای تجاری</button> -->

                        <router-link v-if="(gateway.gateway_type === 0 && gateway.type === 2) || gateway.type === 4" :to="getLink(gateway.id)" class="btn btn-outline-success btn-block h-100">نماد اعتماد</router-link>
                        <button v-else disabled  class="btn btn-outline-success btn-block">نماد اعتماد</button>
                    </div>
                    <div class="p-1 w-50">
                        <!-- <router-link v-if="gateway.gateway_type === 0 && gateway.type === 2" :to="allotmentUrl(gateway.gateway_type) +  gateway.id"  class="btn btn-outline-success btn-block">تسهیم</router-link>
                        <button v-else disabled  class="btn btn-outline-success btn-block">تسهیم</button> -->

                        <a v-if="gateway.gateway_type === gatewayTypes.PARDAKHTYARI || gateway.gateway_type === gatewayTypes.DEDICATED"
                           :data-target="'#gatewayKeyModal' + gateway.id"
                           @click="getSign(gateway.id, gateway.gateway_type)"
                           class="btn btn-outline-success btn-block"
                           data-toggle="modal"
                           href="#"
                        >
                          <span>
                            نمایش کلید
                          </span>
                        </a>
                        <button v-else disabled class="btn btn-outline-success btn-block">
                          تسهیم
                        </button>
                    </div>
                </div>
            </div>


<div v-if="gateway.gateway_type == gatewayTypes.PARDAKHTYARI && gateway.status == gatewayStatus.ACTIVE && gateway.active_terminals" class="row justify-content-center images-row mt-3 mb-2">
    <span class="special-tooltip">
        <span class="tooltip-text">پاسارگاد</span>
        <img :class="{'img-disabled': !gateway.active_terminals.pasargad}" src="/assets/media/psp/pasargad.svg" width="32" height="32">
    </span>
    <span class="special-tooltip">
        <span class="tooltip-text">نوین</span>
        <img :class="{'img-disabled': !gateway.active_terminals.novin}" src="/assets/media/psp/novin.svg" width="32" height="32">
    </span>
    <span class="special-tooltip">
        <span class="tooltip-text">سامان</span>
        <img :class="{'img-disabled': !gateway.active_terminals.saman}" src="/assets/media/psp/saman.svg" width="32" height="32">
    </span>
    <span class="special-tooltip">
        <span class="tooltip-text">آسان پرداخت</span>
        <img :class="{'img-disabled': !gateway.active_terminals.asanpardakht}" src="/assets/media/psp/asanpardakht.svg" width="32" height="32">
    </span>
    <span class="special-tooltip">
        <span class="tooltip-text">ایران کیش</span>
        <img :class="{'img-disabled': !gateway.active_terminals.irankish}" src="/assets/media/psp/irankish.png" width="32" height="32">
    </span>
    <span class="special-tooltip">
        <span class="tooltip-text">ملت</span>
        <img :class="{'img-disabled': !gateway.active_terminals.mellat}" src="/assets/media/psp/mellat.png" class="rounded-md" width="32" height="32">
    </span>
    <span class="special-tooltip">
        <span class="tooltip-text">سپهر</span>
        <img :class="{'img-disabled': !gateway.active_terminals.sepehr}" src="/assets/media/psp/sepehr.png" width="32" height="32">
    </span>
</div>

        </div>
        <!-- Modal -->
        <div :id="'gatewayKeyModal' + gateway.id" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bg-white"
                            id="exampleModalLabel" v-if="gateway.gateway_type === gatewayTypes.PARDAKHTYARI"
                        >
                            {{ $t('label.gateway_sign_key') }} ({{ gateway.title }})
                        </h5>
                        <h5 class="modal-title bg-white"
                            id="exampleModalLabel" v-else-if="gateway.gateway_type === gatewayTypes.DEDICATED"
                        >
                            {{ $t('label.dedicated_sign_key') }} ({{ gateway.title }})
                        </h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                    <textarea
                            :value="'کپی شد'"
                            class="form-control text-center"
                            readonly
                            rows="5"
                            style="resize: none;"
                            v-if="sign_key_copied"
                    >
                    </textarea>
                        <textarea
                                :id="'sign_key' + gateway.gateway_type + '_' + gateway.id"
                                :value="sign_key"
                                class="form-control en_num"
                                dir="ltr"
                                readonly
                                rows="5"
                                style="resize: none;"
                                v-else
                        >
                    </textarea>
                        <div class="d-flex justify-content-center">
                            <button @click="copy_sign_key(gateway.id, gateway.gateway_type)" class="btn btn-outline-secondary mt-2"
                                    type="button">کپی کردن
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {gatewayStatusStr, gatewayVariant, gatewayStatus} from "@/constants/gatewayStatus";
    import {gatewayTypes, gatewayTypeStr, gatewayTypeUpdateUrl } from "@/constants/gatewayTypes";
    import {shopTypeStr} from "@/constants/ShopType";
    import {cardToCardService, dedicatedService, gatewayService} from '@/common/api.service';
    import $ from 'jquery';
    import {shopType} from "@/constants/ShopType";
    import {mapGetters} from 'vuex'
    import {BASE_PATH, PAYMENT_LINK_URL} from "@/common/config";
    import {KTApp} from "@/plugins/core/app";
    import toastr from "toastr";
    import {cardToCardStatus} from "@/constants/cardToCard";

    export default {
        name: "gateway",
        props: ['gateway', 'gateway_type', 'gindex', 'gtype','gsquence'],
        data() {
            return {
                sign_key: '',
                copied: false,
                sign_key_copied: false,
                gatewayTypes: gatewayTypes,
                shopTypeStr: shopTypeStr,
                shop_type: shopType,
                gatewayStatus,
                gatewayTypeStr
            }
        },
        methods: {
            PAYMENT_LINK_URL() {
                return PAYMENT_LINK_URL
            },
            copy_sign_key(id, gateway_type) {
                let copiedLink = $('#sign_key' + String(gateway_type) + '_' + String(id));
                copiedLink.select();
                document.execCommand("copy");

                this.sign_key_copied = true;

                setTimeout(() => {
                    this.sign_key_copied = false;
                }, 1500);
            },
            getSign(id, gateway_type) {
                if (gateway_type == this.gatewayTypes.PARDAKHTYARI) {
                    gatewayService.getSignKey(id).then((response) => {
                        this.sign_key = response.data.data.sign_key;
                    });
                } else if (gateway_type == this.gatewayTypes.DEDICATED) {
                    dedicatedService.getSignKey(id).then((response) => {
                        this.sign_key = response.data.data.sign_key;
                    });
                }
            },
            variant(status) {
                return gatewayVariant(status)
            },
            statusStr(status) {
                return gatewayStatusStr.get(status)
            },
            updateUrl(gatewayType , type = null) {
                return gatewayTypeUpdateUrl(gatewayType ,type)
            },
            getLink(hashid) {
                return "/profile/namad/" + hashid
            },
            settlementSettingsUrl(type) {
                switch (type) {
                    case gatewayTypes.PARDAKHTYARI:
                        if(this.gateway.gateway_type === 0 && this.gateway.type === 2 ){
                            return `/settlement-settings/ipg/${this.gateway.id}/2`;
                        }else{
                            return `/settlement-settings/ipg/${this.gateway.id}`;
                        }
                    case gatewayTypes.IVR:
                        return `/settlement-settings/vip/${this.gateway.id}`;
                }

                return '#';
            },
            enamadPending(hashid){
                return `gateways/update/${hashid}/register-enamad`
            },
            allotmentUrl(type) {
                switch (type) {
                    case gatewayTypes.PARDAKHTYARI:
                        return '/gateways/stakeholders/';
                    case gatewayTypes.DEDICATED:
                        return '/dedicated/stakeholders/';
                }

                return '#';
            },
            copy() {
                var copyText = document.getElementById("myInput" + this.gindex);
                copyText.select();
                document.execCommand("copy");

                this.copied = true;

                setTimeout(() => {
                    this.copied = false;
                }, 1500);
            },
            moneyFormat(price) {
                if (!price) return 0;
                const pieces = parseFloat(price).toFixed(0).split("");
                let ii = pieces.length;
                while ((ii -= 3) > 0) {
                    pieces.splice(ii, 0, ",");
                }
                return pieces.join("");
            },
            rechargeMonthlyCharge(){
                let btn = $('#monthly_recharge_btn');
                KTApp.progress(btn);
                cardToCardService.rechargeGatewayCredit(this.gateway.id).then(response => {
                    let tracking_code = response.data.data.tracking_code
                    window.location = BASE_PATH + '/card-to-card/credit/pay-recharge/' + tracking_code;
                }).catch(({response}) => {
                    this.toastr.error(response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
            }
        },
        computed: {
            cardToCardStatus() {
                return cardToCardStatus
            },
            ...mapGetters("gateway", ["gateways", "hasCartGateway", "status"]),
            ...mapGetters("user", [
                "current_user",
            ]),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }
                return toastr
            },
        },
    }
</script>
<style>
/* gateway card: status edge + compact rows */
.gw-card {
    --gw-accent: #b5b5c3;
    position: relative;
    padding: 0.9rem 1rem;
    border: 1px solid rgba(128, 128, 128, 0.35);
    border-inline-start: 4px solid var(--gw-accent);
    border-radius: 14px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.gw-card.gw-success { --gw-accent: #1bc5bd; }
.gw-card.gw-warning { --gw-accent: #ffa800; }
.gw-card.gw-danger { --gw-accent: #f64e60; }
.gw-card.gw-info { --gw-accent: #3699ff; }
.gw-logo {
    flex: none;
    width: 44px;
    height: 44px;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid rgba(128, 128, 128, 0.35);
    background: rgba(128, 128, 128, 0.12);
    font-weight: 700;
    overflow: hidden;
}
.gw-title {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.6;
}
.gw-status-row {
    text-align: center;
}
.gw-status {
    display: inline-block;
    padding: 1px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 700;
    color: var(--gw-accent);
    background: rgba(128, 128, 128, 0.14);
    border: 1px solid var(--gw-accent);
}
.gw-chip {
    margin: 0.4rem 0;
    padding: 0.35rem 0.75rem;
    border-radius: 10px;
    border: 1px solid rgba(128, 128, 128, 0.3);
    background: rgba(128, 128, 128, 0.08);
    font-size: 0.8rem;
}
.gw-url {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.gw-id input {
    background: transparent;
    color: inherit;
}
.gw-card hr {
    margin: 0.5rem 0;
    border-top: 1px dashed rgba(128, 128, 128, 0.4) !important;
}
.gw-card .ribbon {
    position: static !important;
    display: inline-block;
    margin: 0 0 0.35rem !important;
    padding: 0 10px !important;
    font-size: 0.7rem;
    line-height: 1.7;
    border-radius: 8px !important;
    box-shadow: none !important;
}
.gw-card .my-3 {
    margin-top: 0.2rem !important;
    margin-bottom: 0.2rem !important;
}
.gw-card .images-row {
    scrollbar-width: none;
}
.gw-card .images-row::-webkit-scrollbar {
    display: none;
}
.gw-card .btn-block {
    padding: 0.4rem 0.5rem;
    font-size: 0.8rem;
    border-radius: 10px;
}
@media (max-width: 767.98px) {
    .gw-card {
        margin: 0.25rem 0 !important;
    }
}

#monthly_recharge_btn {
    background-color: transparent!important;
    color: #00bea5!important;
}
#monthly_recharge_btn:hover {
    background-color: #00bea5!important;
    color:white!important;
}

.images-row {
  display: flex;      
  gap: 16px;         
  align-items: center;     
}

.images-row img {
  width: 30px;           
  height: 30px;
  object-fit: cover;       
  border-radius: 50%;        
  border: 2px solid #eee;  
}
@media (max-width: 768px) {
  .images-row {
    flex-wrap: nowrap;
    overflow-x: auto;
    justify-content: flex-start;
    padding-bottom: 8px;
    margin-left: 0;
    margin-right: 0;
  }
  .images-row img {
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
  }
}

.img-disabled {
  filter: grayscale(100%) brightness(0.7);
  opacity: 0.5;
  pointer-events: none;
}

.special-tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.special-tooltip .tooltip-text {
  visibility: hidden;
  opacity: 0;
  width: max-content;
  text-align: center;
  border-radius: 6px;
  padding: 6px 12px;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  right: 50%;
  transform: translateX(50%);
  transition: opacity 0.2s;
  font-size: 13px;
  white-space: nowrap;
}
.special-tooltip:hover .tooltip-text,
.special-tooltip:focus .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>